export const SERVER_TIME_API_HTTP_STATUS_CODES = [
  400, 401, 403, 404, 422, 500, 502, 503, 504,
];

export const SERVER_TIME_API_ERROR_MESSAGE =
  "Error! please refresh your page and try again!";
